.info-panel-body {
  padding: 1rem;
}

.info-description {
  margin-top: 1rem;
  font-size: 0.95rem;
}

.info-image {
  padding-right: 20px;
  max-width: 100%;
  height: auto;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiQzpcXGlvXFxldGV4LWh1YnN0ZXJcXHNyY1xcRnJvbnRlbmRcXGhlYWRsZXNzXFxtb2R1bGVzXFxldGV4XFxzcmNcXGNvbXBvbmVudHNcXHNsaWRlb3V0XFxpbmZvLXBhbmVsIiwic291cmNlcyI6WyJpbmZvUGFuZWwuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFOzs7QUFHRjtFQUNFO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTtFQUNBIiwic291cmNlc0NvbnRlbnQiOlsiLmluZm8tcGFuZWwtYm9keSB7XHJcbiAgcGFkZGluZzogMXJlbTtcclxufVxyXG5cclxuLmluZm8tZGVzY3JpcHRpb24ge1xyXG4gIG1hcmdpbi10b3A6IDFyZW07XHJcbiAgZm9udC1zaXplOiAwLjk1cmVtO1xyXG59XHJcblxyXG4uaW5mby1pbWFnZSB7XHJcbiAgcGFkZGluZy1yaWdodDogMjBweDtcclxuICBtYXgtd2lkdGg6IDEwMCU7XHJcbiAgaGVpZ2h0OiBhdXRvO1xyXG59XHJcbiJdfQ== */